import { render, staticRenderFns } from "./ViewPasswordRecovery.vue?vue&type=template&id=2be1bce5&scoped=true&"
import script from "./ViewPasswordRecovery.vue?vue&type=script&lang=ts&"
export * from "./ViewPasswordRecovery.vue?vue&type=script&lang=ts&"
import style0 from "./ViewPasswordRecovery.vue?vue&type=style&index=0&id=2be1bce5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be1bce5",
  null
  
)

export default component.exports